<div
  *ngIf="!is_list_running"
  class="sp-width__full sp-height__full sp-background__accent-contrast sp-border-radius__s sp-padding__x2">
  <app-home-header
    icon="receipt_long"
    [title]="'SHARED.TOOLBAR_ORDERS_LABEL'"
    (refresh)="onRefresh()"
    (see_all)="onSeeAllClick()"></app-home-header>

  <div class="sp-margin__top-x2"></div>
  <div
    *ngFor="let order of orders"
    class="sp-padding__vert sp-width__full">
    <app-home-orders-item [order]="order"></app-home-orders-item>
  </div>

  <app-shared-empty-message
    *ngIf="!orders?.length"
    [empty_message]="'ORDERS.EMPTY_LABEL'"></app-shared-empty-message>
</div>

<div
  *ngIf="is_list_running"
  class="sp-width__full sp-height__full">
  <app-loading [card_radius]="'sp-border-radius__s'"></app-loading>
</div>
